<template>
    <ul id="navscroll">
        <li @click="clickLi(item)" v-for="(item, index) in list" :key="index">{{ item.name }}</li>
    </ul>
</template>
<script>
export default {
    data() {
        return {
            list: [{
                name: '订单详情',
                scroll: 0
            }, {
                name: '客户报价单',
                scroll: 550
            }, {
                name: '审核项目',
                scroll: 1100
            }]
        }
    },
    methods: {
        clickLi(x) {
            this.$emit('scroll', x)
        }
    }
}
</script>
<style>
#navscroll {
    display: flex;
    margin-top: 10px;
}

#navscroll li {
    padding:0 10px;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/wuliu/caiwu/navShenhe.vue